import NiceModal from '@ebay/nice-modal-react';
import { enqueueSnackbar } from 'notistack';

import { getMessage } from '@gef-ui/localization/messages';

import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import { getTaskId } from 'features/views/taskDetail/selectors';

import { TASK_COPY_EMAIL_FORM } from './form';

export const sendEmail =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const state = getState();
		const formData = await getFormData(TASK_COPY_EMAIL_FORM);
		const taskId = getTaskId(state);

		const body = {
			emails: [formData?.email],
			taskId,
			notifyManagers: false,
		};

		dispatch(
			fetch.actions.post(fetch.constants.urls.taskEmailCopy, {
				body,
				onSuccess: [
					() => {
						enqueueSnackbar(getMessage('toastr:approveSendTaskCopyEmail'), { variant: 'success' });
						return NiceModal.hide(MODALS.task_copy_email);
					},
				],
				onError: [() => NiceModal.hide(MODALS.task_copy_email)],
			}),
		);
	};
